import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";

import React from "react";
import {ExperienceLevel, Skill, StyledBaseProps} from "@betrue/shared/interfaces";
import {ExperienceView} from "../experience/experience.view";

export interface SkillTagProps extends StyledBaseProps {
  skill: Skill,
  onDelete?: (skill: Skill) => void,
  onAdd?: (skill: Skill) => void
  level?: ExperienceLevel
}

export const SkillTag = styled((props: SkillTagProps) => (
  <span className={props.className}>
    <div>
      <span>{props.skill.label}</span>
      {props.level ? <ExperienceView level={props.level}/> : ''}
    </div>
    {props.onDelete ? <CloseIcon onClick={(e) => props.onDelete(props.skill)}/> : ''}
    {props.onAdd ? <AddIcon onClick={(e) => props.onAdd(props.skill)}/> : ''}

  </span>
))`
  width: fit-content;
  height: ${(props) => props.level ? '30px' : '30px'};
  margin: 2px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-sizing: content-box;
  padding: 0 4px 0 4px;
  outline: 0;
  overflow: hidden;
  align-items: center;
  display: flex;

  &.active {
    background-color: #99999999;

  }


  & div {
    padding-right: 4px;
  }

  & .skill-level-container {
    height: 6px;
  }

  &:focus {
    border-color: #40a9ff;
    background-color: #e6f7ff;
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px 4px 4px 0;

  }
`;
